module.exports = __webpack_public_path__ + "img/alert.28544b75.png";